import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import FamilyHistory from "../../components/patient-timeline/family-history"
const FamilyHistoryContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <FamilyHistory />
      </div>
    </div>
  )
}

export default FamilyHistoryContainer